import { render } from "./star.svg?vue&type=template&id=03066366"
const script = {}
script.render = render

export default script